import React, { useState, useEffect } from "react";
import { Form, Collapse, Card, Table, notification } from "antd";
import jsonfile from "./voucher.json";
import { Link, useHistory } from "react-router-dom";
import { CisUI } from "../../../util/CISUI";
import "react-smart-data-table/dist/react-smart-data-table.css";
import IntlMessages from "util/IntlMessages";
import Config from "../../../util/config";
import AdvancedSearchBeneficiary from "../../../util/AdvanceSearchWithBeneficiary";
import axios from "../../../util/Api";
import moment from "moment";
import localStorage from "react-secure-storage";
const Panel = Collapse.Panel;

const VoidedVoucherList = () => {
  const history = useHistory();
  const [state, setState] = useState({
    reqURL: Config.apiserver + jsonfile.urls.voidedlist,
    filtervalue: "",
    subtitle: "",
  });
  const [data, setData] = useState([]);

  const [form] = Form.useForm();

  useEffect(() => {
    getData();
  }, [state.reqURL]);

  const getData = (url = "") => {
    let urls = state.reqURL;
    if (url !== "") {
      urls = url;
    }
    document.getElementById("loader").style.display = "block";
    axios
      .get(urls)
      .then((res) => {
        // console.log(res)
        if (res.data.status === 1) {
          console.log("data", res.data.data);
          let newData = [];
          res.data.data.map((item, index) => {
            newData.push({ ...item, key: item.voucher_no });
          });
          setData(newData);
        } else {
          setData([]);
          notification.warning({
            message: "Alert",
            type: "warning",
            description: res.data.msg,
          });
        }
        document.getElementById("loader").style.display = "none";
      })
      .catch((errors) => {
        // console.log(errors);
        document.getElementById("loader").style.display = "none";
      });
  };

  const getPrintAction = (row) => {
    if (row.is_multy === 0) {
      return (
        <Link to={"../" + jsonfile.urls.mview + "/" + row.voucher_no}>
          <span style={{ fontWeigh: "bold" }}>{row.voucher_no}</span>
        </Link>
      );
    } else {
      return (
        <Link to={"../" + jsonfile.urls.mview + "/" + row.voucher_no}>
          <span style={{ fontWeigh: "bold" }}>{row.voucher_no}</span>
        </Link>
      );
    }
  };

  const columns = [
    {
      title: <IntlMessages id="SL NO." />,
      dataIndex: "sl_no",
      key: "sl_no",
      width: "10px",
      render: (value, row, index) => index + 1,
    },
    {
      title: <IntlMessages id="Date" />,
      dataIndex: "date",
      key: "date",
      width: "100px",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      render: (value, row, index) => CisUI().DateFormat(value),
    },
    {
      title: <IntlMessages id="Voucher No#" />,
      dataIndex: "voucher_no",
      key: "voucher_no",
      width: "100px",
      // sorter: (a, b) => a.voucher_no.length - b.voucher_no.length,
      render: (value, row, index) => getPrintAction(row),
    },
    {
      title: <IntlMessages id="Account" />,
      dataIndex: "head",
      key: "head",
      width: "250px",
      sorter: (a, b) => a.head.localeCompare(b.head),
      // render: (value, row, index) => row.payment_head !== null ? row.payment_head : row.receipt_head
    },
    {
      title: <IntlMessages id="Receipt(₵)" />,
      dataIndex: "debit",
      key: "debit",
      align: "right",
      width: "100px",
      sorter: (a, b) => a.debit - b.debit,
      render: (value, row, index) => CisUI().getCurrencyFormattedV2(value),
    },
    {
      title: <IntlMessages id="Payment(₵)" />,
      dataIndex: "credit",
      key: "credit",
      align: "right",
      width: "100px",
      sorter: (a, b) => a.credit - b.credit,
      render: (value, row, index) => CisUI().getCurrencyFormattedV2(value),
    },
    {
      title: <IntlMessages id="Payment Method" />,
      dataIndex: "type",
      key: "type",
      width: "120px",
    },
    {
      title: <IntlMessages id="Reference" />,
      dataIndex: "reference",
      key: "reference",
      width: "80px",
    },
    {
      title: <IntlMessages id="Created By" />,
      dataIndex: "user_name",
      key: "user_name",
      sorter: true,
      width: "200px",
    },
    {
      title: <IntlMessages id="Beneficiary" />,
      dataIndex: "source",
      key: "source",
      width: "300px",
    },
    {
      title: <IntlMessages id="Status" />,
      dataIndex: "status",
      key: "status",
      width: "100px",
      render: (value, row, index) => CisUI().getTransactionStatus(value),
    },
    {
      title: <IntlMessages id="Check Status" />,
      dataIndex: "checque_status",
      key: "checque_status",
      width: "120px",
      render: (value, row, index) => CisUI().getChecqueStatus(value),
    },
  ];

  const onFinish = (values) => {
    // console.log('Received values of form: ', values);
    const qsup = CisUI().getQueryStrings(values);
    //reqURL = reqURL+"/?"+qsup;
    history.push("?" + qsup);
    const newURL = Config.apiserver + jsonfile.urls.voidedlist + "/?" + qsup;
    setState({ reqURL: newURL });
  };

  let searchView = "";
  if (jsonfile.has_search) {
    searchView = (
      <Card className="advance-search-card">
        <Collapse accordion expandIconPosition="right" defaultActiveKey={["1"]}>
          <Panel header="Advance Search" key="1">
            <Form
              key={5}
              form={form}
              {...CisUI().formItemLayout}
              name="advanced_search"
              className="ant-advanced-search-form"
              onFinish={onFinish}
            >
              {AdvancedSearchBeneficiary(jsonfile.input, "", 1, "date", CisUI().PeriodFiled(form), form)}
            </Form>
          </Panel>
        </Collapse>
      </Card>
    );
  }

  const ListActionButtonReportXLS = (
    url = "",
    querystring = "",
    apiURL = "",
    dataParameter = "",
    filename = "",
    fullJson = {},
    subtitle = "",
    printmode = "portrait",
  ) => (
    <div className="no-print">
      <button
        className="btn btn-export-excel btn-md"
        onClick={(e) => getAPIDataXLS(apiURL, querystring)}
        title="Export to Excel"
      >
        <i className="fas fa-file-excel" style={{ marginRight: "5px" }} />
        Export
      </button>
    </div>
  );

  const getAPIDataXLS = async (APIUrl, qrystring) => {
    try {
      let URL = APIUrl + "/xlsx?token=" + localStorage.getItem("token") || 0 + qrystring;
      if (APIUrl.includes("?")) {
        const sp = APIUrl.split("?");
        URL = sp[0] + "xlsx?" + sp[1] + "&token=" + localStorage.getItem("token") || 0;
      }

      console.log("URL :" + URL);
      // window.open(URL,"_blank");
      const res = await axios.get(URL, {
        responseType: "blob", // Important: Response should be treated as a binary file
      });

      // console.log("response", res)

      const contentType = res.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await res.data.text();
        // console.log("text", text);
        const json = JSON.parse(text);
        // console.log("json", json);
        if (json.status === 0) {
          notification.warning({
            message: "Alert",
            type: "warning",
            description: json.msg,
          });
          // console.log('status', 0)
          return;
        }
      }

      if (res.data.size > 0) {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }),
        );
        const link = document.createElement("a");
        link.href = url;
        // link.setAttribute("download", "VoidedVoucher.xlsx");
        // document.body.appendChild(link);
        link.download = "VoidedVoucher.xls";

        link.click();
        link.remove();
        // window.URL.revokeObjectURL(url);
      } else {
        alert("No data found.");
      }
    } catch (error) {
      console.error("Download failed:", error);
      alert("Error occurred while downloading file.");
    }
  };

  // const getAPIDataXLS =  (APIUrl, qrystring) => {
  //     // try{
  //     let URL = APIUrl + "xlsx?" + qrystring + "&token=" + localStorage.getItem("token") || 0;
  //     if (APIUrl.includes("?")) {
  //         const sp = APIUrl.split("?");
  //         URL = sp[0] + "xlsx?" + sp[1] + "&token=" + localStorage.getItem("token") || 0;
  //     }
  //
  //     console.log("URL :" + URL);
  //     // window.open(URL,"_blank");
  //     axios.get(URL)
  //         .then(res => {
  //         console.log(res);
  //     })

  // console.log("response", res)

  // const contentType = res.headers["content-type"];
  // if (contentType && contentType.includes("application/json")) {
  //     const text = await res.data.text();
  //     console.log("text", text);
  //     const json = JSON.parse(text);
  //     // console.log("json", json);
  //     if(json.status === 0){
  //         notification.warning({
  //             message: 'Alert',
  //             type: "warning",
  //             description: json.msg
  //         });
  //         console.log('status', 0)
  //         return;
  //     }
  // }

  // const url = window.URL.createObjectURL(
  //     new Blob([res.data], {
  //         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     })
  // );
  // const link = document.createElement('a');
  // link.href = url;
  // link.download = 'VoidedVoucher.xlsx';
  // link.click();
  // document.body.removeChild(link);

  // if (res.data.size > 0) {
  //     const url = window.URL.createObjectURL(
  //         new Blob([res.data], {
  //             type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //         })
  //     );
  //     const link = document.createElement("a");
  //     link.href = url;
  //     // link.setAttribute("download", "VoidedVoucher.xlsx");
  //     // document.body.appendChild(link);
  //     link.download = 'VoidedVoucher.xlsx';
  //
  //     link.click();
  //     link.remove();
  //     // window.URL.revokeObjectURL(url);
  // } else {
  //     alert("No data found.");
  // }
  // } catch (error) {
  //     console.error("Download failed:", error);
  //     alert("Error occurred while downloading file.");
  // }
  // };

  const getExtra = (
    <>
      {ListActionButtonReportXLS(
        "../" + jsonfile.urls.add,
        "",
        state.reqURL,
        "data",
        "voided_vouchers",
        jsonfile,
        "Journal",
        "landscape",
      )}
    </>
  );

  return (
    <>
      {CisUI().showLoading}
      {searchView}
      <Card title={jsonfile.voidedlisttitle} extra={getExtra}>
        {/*{*/}
        {/*    selectedRowKeys.length > 0 &&*/}
        {/*    <div style={{marginBottom: "5px"}}>*/}
        {/*        <button onClick={handleMultiplePrint} className="btn-text-adjust btn"><i className="fas fa-print"></i> Print</button>*/}
        {/*        <button onClick={handleMultipleVoid} className="btn-text-adjust btn"><i className="fas fa-circle" style={{ color: 'red' }}></i> Void</button>*/}
        {/*    </div>*/}
        {/*}*/}
        {data.length > 0 ? (
          <Table
            className="entriesTable"
            columns={columns}
            // rowSelection={rowSelection}
            // rowKey={(record) => record.id}
            // pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '30', '50', '100','200','500']}}
            pagination={{ defaultPageSize: 50, position: ["bottomCenter"] }}
            dataSource={data}
            scrollToFirstRowOnChange={true}
            expandable={{
              defaultExpandAllRows: true,
            }}
            scroll={{
              x: 1500,
            }}
          />
        ) : (
          ""
        )}
      </Card>
    </>
  );
};

export default VoidedVoucherList;
